import Axios from 'axios'
const API_HOST = process.env.VUE_APP_API_HOST
const API_VERSION = process.env.VUE_APP_API_VERSION
const ShortLinkService = {
  /**
   * @description get short link
   *
   * @returns {object}
   */
  short(params) {
    const apiURL = `${API_HOST}/${API_VERSION}/short_link`
    return Axios.request({
      method: 'POST',
      url: apiURL,
      headers: {},
      data: params
    })
      .then(res => {
        if (res && res.data) {
          return res.data
        }
        return { data: [] }
      })
      .catch(err => {
        console.error(err)
        return null
      })
  }
}
export default ShortLinkService
